// extracted by mini-css-extract-plugin
module.exports = {"panel":"portalFlyout_panel__qpMYz","flyoutFadeIn":"portalFlyout_flyoutFadeIn__vSBf4"};